var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-wall"},[(_vm.projects.length)?_vm._l((_vm.projects),function(item){return _c('ProjectWallTile',{key:item.id,attrs:{"project":item}})}):_vm._e(),_vm._v(" "),_c('Arc',{attrs:{"random-range-rotation":{ min: 10, max: 220 },"random-range-position-x":[
      { min: -5, max: 0 },
      { min: 86, max: 95 }
    ],"random-range-position-y":{ min: 70, max: 80 }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }